import type { CSSProperties } from "react";

type CalculatePopupPositionParams = {
	anchorRect: DOMRect;
	popupWidth: number;
	topOffset?: number;
	viewportGutter?: number;
	viewportWidth?: number;
};

type PopupPositionStyle = Pick<
	CSSProperties,
	"top" | "left" | "right" | "width"
>;

export const calculatePopupPosition = ({
	anchorRect,
	popupWidth,
	topOffset = 8,
	viewportGutter = 12,
	viewportWidth = window.innerWidth,
}: CalculatePopupPositionParams): PopupPositionStyle => {
	const width = Math.min(popupWidth, viewportWidth - viewportGutter * 2);

	const left = Math.min(
		Math.max(anchorRect.right - width, viewportGutter),
		viewportWidth - width - viewportGutter,
	);

	return {
		top: anchorRect.bottom + topOffset,
		left,
		right: "auto",
		width,
	};
};
